import type { GetStaticPaths, GetStaticProps } from 'next'

/* blocks */
import Layout from '@/cmp/templates/Layout/Layout'
import Industries from '@/cmp/templates/Industries/Industries'

/* utils */
import {
  newIndustryDetailsQuery,
  NewIndustryPageAttributes,
  NewIndustryPageResponse
} from '@/utils/queries/industries'
import { getStrapiGraphqlData } from '@/utils/api/wrapper'
import { constructMetadataFromStrapiData } from '@/utils/functions/strapi'
import {
  INSTANT_REVALIDATION,
  TEN_MINS_REVALIDATION
} from '@/utils/constants/revalidation'
import { capture404PageError } from '@/utils/functions/elk-server'

interface Props {
  page: NewIndustryPageAttributes
}

function IndustriesPage({ page }: Props): JSX.Element {
  return (
    <Layout
      title={page.seo?.title}
      meta={constructMetadataFromStrapiData(page?.seo)}
      canonical={`/industries/${page.slug}/`}
    >
      <Industries data={page} />
    </Layout>
  )
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const slug = params?.slug?.toString() as string

  const result = await getStrapiGraphqlData<NewIndustryPageResponse>(
    newIndustryDetailsQuery.loc?.source.body,
    { slug }
  )

  if (!result || result.page.data.length === 0) {
    capture404PageError(`/industries/${slug}/`)
    return { notFound: true, revalidate: INSTANT_REVALIDATION }
  }

  return {
    props: {
      page: result.page.data[0].attributes
    },
    revalidate: TEN_MINS_REVALIDATION
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  return { paths: [], fallback: 'blocking' }
}

export default IndustriesPage
